// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on.
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageHeader } from '../../components/ui/page-header'
import '../../shared/shell/strings'

export const Route = createFileRoute('/platform/config')({
  staticData: { screenId: 'ConsoleAppConfigScreen', access: 'platform.config.manage' },
  component: ConsoleAppConfigScreen,
})

function ConsoleAppConfigScreen() {
  const { t } = useTranslation()
  return (
    <main data-testid="ConsoleAppConfigScreen">
      <PageHeader title={t('shell.nav.config')} titleTestId="consoleAppConfig_titleValue" />
    </main>
  )
}
